<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <wizard :wizardHeadings="importWizard.wizardHeadings" :isSubmitting="importWizard.submitting"
                        :skipSubmissionForCurrentPanel="importWizard.skipSubmissionForCurrentWizardPanel" :resetWizard="importWizard.resetWizard"
                        :canMoveToNextPanel="importWizard.canMoveOnToNextPanel" :showDoneButton="true"
                        @stepCompleteNext="onImportWizardStepCompleteNext" @stepCompletePrevious="onImportWizardStepCompletePrevious"
                        @beginSubmission="submitCurrentImportWizardForm" @wizardComplete="importDone">

                    <div step-id="1">
                        <h5 class="mb-5">Upload File</h5>
                        <div class="text-danger">
                            {{fileUpload.errorMessage}}
                        </div>
                        <div class="alert alert-primary" role="alert">
                            Please note: Only documents in Excel format will be accepted
                        </div>
                        <label>Pricing File</label>
                        <div class="custom-file">
                            <input type="file" class="custom-file-input" id="customFile" @change="onFileAttach" accept=".xls, .xlsx">
                            <label class="custom-file-label" for="customFile">{{fileUpload.name}}</label>
                        </div>

                    </div>
                    <div step-id="2">
                        <delivery-pricing-bulk-import-validation
                                :canSubmit="importConfirmation.canSubmit"
                                :dateToBeEffective="importConfirmation.effectiveDate"
                                :productsToImport="importConfirmation.productsToImport"
                                @effectiveDateChange="onEffectiveDateChange"
                                @confirmationSubmitComplete="onConfirmationSubmitComplete"></delivery-pricing-bulk-import-validation>
                    </div>
                    <div step-id="3">
                        <h5>Importing</h5>
                        <loading-spinner :showSpinner="importingPricing"></loading-spinner>
                        <div class="alert alert-error" role="alert" v-if="importErrorMessage.show">
                            {{importErrorMessage.message}}
                        </div>
                        <div class="alert alert-success" role="alert" v-if="importSuccessMessage.show">
                            {{importSuccessMessage.message}}
                        </div>
                    </div>
                </wizard>
            </div>
        </div>
    </div>
</div>
